import React from 'react';
import { Interp, css, toList } from '../../lib/render.jsx';
import { Kruis } from '../Iconen.jsx';

export default function Limits({ v }) {
  if (!v.showLimits) return null;
  return (
    <>
      {' '}
      <div className="gp-laag" style={{ "position": "fixed", "inset": "0", "background": "rgba(36,27,58,.7)", "display": "flex", "alignItems": "center", "justifyContent": "center", "zIndex": "97", "padding": "20px" }} onClick={v.closeLimits}>
        <div className="gp-venster gp-vast" style={{ "width": "min(560px,100%)", "maxHeight": "calc(100vh - 80px)", "overflow": "hidden", "padding": "24px", "display": "flex", "flexDirection": "column", "gap": "14px", "boxSizing": "border-box" }} onClick={v.stopProp}>
          <div style={{ "display": "flex", "alignItems": "center", "gap": "10px", "flex": "0 0 auto" }}>
            <div style={{ "display": "flex", "flexDirection": "column", "gap": "2px", "flex": "1 1 auto", "minWidth": "0" }}>
              <div style={{ "fontSize": "19px", "fontWeight": "700", "lineHeight": "1.2" }}>
                Limieten en aantallen
              </div>
            </div>
            <button onClick={v.closeLimits} title="Sluiten" style={css(v.sluitStyle)}>
              <Kruis maat={22} />
            </button>
          </div>
          <div style={{ "display": "grid", "gridTemplateColumns": "1.15fr .8fr .9fr", "gap": "10px", "padding": "0 11px", "fontSize": "11px", "fontWeight": "700", "letterSpacing": ".05em", "textTransform": "uppercase", "color": "var(--tekst-3)", "flex": "0 0 auto" }}>
            <span>
              Wat
            </span>
            <span>
              Limiet
            </span>
            <span>
              Nu
            </span>
          </div>
          <div style={{ "display": "flex", "flexDirection": "column", "gap": "5px", "flex": "1 1 auto", "minHeight": "0", "overflowY": "auto" }}>
            {toList(v.limitRows).map((l, $index) => (
              <React.Fragment key={$index}>
                <div style={css(l?.rowStyle)}>
                  {' '}
                  <span style={{ "minWidth": "0" }}>
                    <Interp v={l?.what} />
                    <span style={{ "display": "block", "marginTop": "2px", "fontSize": "11px", "fontWeight": "600", "color": "var(--tekst-3)" }}>
                      <Interp v={l?.sort} />
                    </span>
                  </span>
                  {' '}
                  <span style={{ "minWidth": "0", "color": "var(--ink)" }}>
                    <Interp v={l?.limit} />
                  </span>
                  {' '}
                  <span style={{ "minWidth": "0", "color": "var(--tekst-2)" }}>
                    <Interp v={l?.now} />
                  </span>
                  {' '}
                </div>
              </React.Fragment>
            ))}
          </div>
          <button onClick={v.closeLimits} className="gp-btn pink" style={css(v.hoofdKnopStyle)}>
            Klaar
          </button>
        </div>
      </div>
      {' '}
    </>
  );
}
